export default __webpack_public_path__ + "static/media/usersIcon.6a8fe38e.svg";